import { Alert, IconButton, Tooltip } from '@mui/joy';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { CircleExclamation, InfoIcon, OpenIcon } from '@/shared/icons/Icons';
import type { DetailedCaseTemplate } from '~/common/types/case/caseTemplate';
import { type UseToggle } from '@/shared/hooks/UseToggle';

type Props = {
  template?: DetailedCaseTemplate;
  toggle: UseToggle;
};

const TemplateAlerts: React.FC<Props> = ({ template, toggle }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const templateHasTasksWithoutAdmins = useMemo(() => {
    if (!template?.tasks?.length) {
      return false;
    }
    return template.tasks.some((x) => !x.assignedUserIds.length);
  }, [template]);

  if (!template) return null;

  return (
    <>
      <Alert
        size="sm"
        color="primary"
        startDecorator={<InfoIcon />}
        endDecorator={
          <Tooltip title={t('navigateToType', { type: t('caseTemplate') })}>
            <IconButton
              variant="plain"
              onClick={() => {
                navigate('/team/settings/case');
                toggle.hide();
              }}
            >
              <OpenIcon />
            </IconButton>
          </Tooltip>
        }
      >
        <div>
          <p>
            {`${t('caseCreationMasterTemplateRemark.description')} ${t(
              'caseCreationMasterTemplateRemark.appointment',
              {
                count: template.appointments.length,
              },
            )}, ${t('caseCreationMasterTemplateRemark.document', {
              count: template.caseTemplateFiles.length,
            })}, ${t('caseCreationMasterTemplateRemark.note', {
              count: template.notes.length,
            })}, ${t('caseCreationMasterTemplateRemark.task', {
              count: template.tasks.length,
            })}.`.trim()}
          </p>
        </div>
      </Alert>

      {templateHasTasksWithoutAdmins && (
        <Alert size="sm" color="warning" startDecorator={<CircleExclamation />}>
          <p>{t('caseCreationMasterTemplateRemark.tasksWithoutAdminWarning')}</p>
        </Alert>
      )}
    </>
  );
};

export default TemplateAlerts;
